(() => {
  const padNumber = (num, size) => String(num).padStart(size, "0");

  const buildUrl = (prefix, n, pad, suffix) => {
    // If your Cloudinary filenames include the padded number at the end, e.g. ..._001.jpg
    return `${prefix}${padNumber(n, pad)}${suffix}`;
  };

  const createLightbox = () => {
    let overlay = document.querySelector(".hw-lightbox");
    if (overlay) return overlay;

    overlay = document.createElement("div");
    overlay.className = "hw-lightbox";
    overlay.innerHTML = `
      <button class="hw-lightbox__close" type="button" aria-label="Close"></button>
      <img class="hw-lightbox__img" alt="">
    `;
    document.body.appendChild(overlay);

    const close = () => overlay.classList.remove("is-open");
    overlay.addEventListener("click", (e) => {
      if (e.target.classList.contains("hw-lightbox") || e.target.classList.contains("hw-lightbox__close")) {
        close();
      }
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") close();
    });

    return overlay;
  };

  const initGallery = (root) => {
    const prefix = root.dataset.prefix || "";
    const suffix = root.dataset.suffix || ".jpg";
    const start = parseInt(root.dataset.start || "1", 10);
    const end = parseInt(root.dataset.end || "1", 10);
    const pad = parseInt(root.dataset.pad || "3", 10);

    if (!prefix || !Number.isFinite(start) || !Number.isFinite(end) || start > end) return;

    const frag = document.createDocumentFragment();

    for (let i = start; i <= end; i += 1) {
      const url = buildUrl(prefix, i, pad, suffix);

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "hw-gallery__item";

      const img = document.createElement("img");
      img.loading = "lazy";
      img.decoding = "async";
      img.src = url;
      img.alt = `Gallery image ${i}`;
      img.className = "hw-gallery__img";

      btn.appendChild(img);
      frag.appendChild(btn);
    }

    root.appendChild(frag);

    const lightbox = createLightbox();
    const lightboxImg = lightbox.querySelector(".hw-lightbox__img");

    root.addEventListener("click", (e) => {
      const item = e.target.closest(".hw-gallery__item");
      if (!item) return;

      const img = item.querySelector("img");
      if (!img) return;

      lightboxImg.src = img.src;
      lightbox.classList.add("is-open");
    });
  };

  const boot = () => {
    document.querySelectorAll(".hw-gallery").forEach(initGallery);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
